import React, { useState, useEffect } from 'react';
import MasterTable from "../common/MasterTable";
import RetailerModal from '../Retailer/RetailerModal';
import { axiosPostApi } from '../../helpers/interceptorServices';
import { apiList } from '../../helpers/apiList';
import CustomAlert from '../../helpers/CustomAlert';
import { toast } from 'react-toastify';
import Loader from '../Loader/Loader';

const Retailer = () => {
  const loggedInUserName = sessionStorage.getItem('username');
  const [noData, setNoData] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [retailerData, setRetailerData] = useState([]);
  const [modalAction, setModalAction] = useState('');
  const [loading, setLoading] = useState(true);
  const [pageDetails, setPageDetails] = useState(null);
  const [pageSize, setPageSize] = useState(10)
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    fetchRetailerData(1);
  }, []);

  const fetchRetailerData = async (currentPage) => {
    try {
      const requestBody = {
        username: loggedInUserName,
        status: ""
      };

      const response = await axiosPostApi(
        `${apiList.FETCH_RETAILER_DATA}?&pageSize=${pageSize}&pageNo=${currentPage}`,
        requestBody
      );

      if (response?.data?.status === true && response?.data?.respCode === "00") {
        setPageDetails(response?.data?.pageDetails);
        const modifiedData = modifyStructure(response?.data?.data);
        setRetailerData(modifiedData);
        if (modifiedData?.length === 0) {
          setNoData(true);
        } else {
          setNoData(false);
        }
      } else {
        setNoData(true);
        setRetailerData([]);
        if (response?.data?.respCode !== "01" && response?.data?.data !== null) {
          CustomAlert({
            title: "Failed to Fetch Data",
            text: response?.data?.message || 'No data available for the specified criteria.',
            icon: 'error',
            confirmButtonText: 'Retry'
          });
        }
      }

    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry"
      });
    } finally {
      setLoading(false);
    }
  };

  const modifyStructure = (response) => {
    return response && response?.map((item, index) => ({
      ...item,
      id: index + 1,
    }));
  };

  const handleAuthorization = (authData) => {
    const loggedInUserName = sessionStorage.getItem('username');
    const requestBody = {
      ...authData,
      username: loggedInUserName,
      status: '1'
    };

    axiosPostApi(apiList.AUTH_RETAILER_DATA, requestBody)
      .then((response) => {
        if (response?.status === 200 && response?.data?.respCode === '00') {
          toast.success("Retailer Authorized successfully!");
          fetchRetailerData(1);
        } else {
          CustomAlert({
            title: "Failed to Authorized retailer",
            text: response.data?.message || 'Invalid credentials. Please try again!',
            icon: 'error',
            confirmButtonText: 'Retry'
          });
        }
      })
      .catch((error) => {
        console.error("Error Authorized retailer", error);
        toast.error("Failed to Authorized retailer.");
      });
  };

  const retailerHeaders = [
    'Retailer Name',
    "Retailer Email Id",
    'Address',
    'Contact Person Name 1',
    'Contact Person 1 Mobile No',
    'Contact Person Name 2',
    'Contact Person 2 Mobile No',
    'Settlement Bank Name',
    'Settlement Account No',
    'Settlement Account Name',
    'Settlement IFSC Code',
    "MCC Code",
    "MCC Description",
    'Status'
  ];

  const retailerHeaderToKeyMap = {
    'Retailer Name': 'name',
    "Retailer Email Id": "emailId",
    'Address': 'address',
    'Contact Person Name 1': 'firstContactPersonName',
    'Contact Person 1 Mobile No': 'firstContactPersonMobileNo',
    'Contact Person Name 2': 'secondContactPersonName',
    'Contact Person 2 Mobile No': 'secondContactPersonMobileNo',
    'Settlement Bank Name': 'bankName',
    'Settlement Account No': 'accountNo',
    'Settlement Account Name': 'accountHolderName',
    'Settlement IFSC Code': 'ifscCode',
    "MCC Code": "mccCode",
    "MCC Description": "mccDesc",
    'Status': 'authStatus'
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditData({});
    setModalAction('');
  };

  const handlerRetailer = (data, actionType = 'view') => {
    setModalAction(actionType);
    if (actionType === 'add') {
      setEditData({});
      setShowModal(true);
    } else {
      let reData = retailerData.find((item) => item?.id === data?.id);
      if (reData) {
        setEditData(reData);
        setShowModal(true);
      }
    }
  };

const pageSizeCount = pageDetails === null  ? 0 : pageDetails.pageSize;
const totalRecord = pageDetails === null  ? 0 : pageDetails.totalRecords;


return (
    <div>
       {loading ?
      <Loader/>: 
        <>
      <MasterTable
        headers={retailerHeaders}
        data={retailerData}
        handleAction={handlerRetailer}
        filterFields={['name']}
        entityType="Retailer"
        headerToKeyMap={retailerHeaderToKeyMap}
        loading={loading}
        noData={noData}
        handleAuth={handleAuthorization}
        pageDetails={pageDetails}
        currentPage={currentPage}
        pageSize={pageSizeCount}
        totalRecord={totalRecord}
        fetchNextData={fetchRetailerData}
        setCurrentPage={setCurrentPage}
      />
      <RetailerModal
        show={showModal}
        handleClose={handleCloseModal}
        editData={editData}
        action={modalAction}
        fetchRetailerData={fetchRetailerData}
      />
       </>}
    </div>
  )
}

export default Retailer;
